import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useDeleteUserMutation } from '@/apis/users';
import { useToastMessageRequest } from '@/hooks';
import { usersSelectors } from '@/redux/users';
import { closeDeleteUserModal } from '@/redux/users/slice';

export const useDeleteUserModal = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector(usersSelectors.isDeleteUserModalOpenSelector);
  const user = useSelector(usersSelectors.selectedUserForModalSelector);
  const [deleteUser, { isSuccess, ...requestParams }] = useDeleteUserMutation();

  useToastMessageRequest({ isSuccess, ...requestParams });

  const closeModal = () => {
    dispatch(closeDeleteUserModal());
  };

  const confirmDeleting = () => {
    deleteUser(user?.id ?? '');
  };

  useEffect(() => {
    if (isSuccess) {
      closeModal();
    }
  }, [isSuccess]);

  return { isOpen, user, closeModal, confirmDeleting };
};
